module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAASRJREFUKBWVUjtuhDAUfEY5wB5hU1OEjmOE3GBzBE7CEZIbxGmRqKjoSEGHtA2iodnUFGTG8dOyGK0SS+Yx82aef8/IZhRFkRljnkEnfraI7bIsn3me27XcKIDpANMbcKbcTrQo8ooiF+ac2RvPwIcdw5a6oMAjC0Q+8474FyPlukMx/owfZP8zsPoLV753xnv1sgdkE1WkaSpxHCsMYtd10jSN43G5TxE/qmKi73uFN5G8Gn0iibD3r7WqrmsZx3FNOUx+PejjmdsNKVVVyTRNjmYkhngt439Ls92y8zxLWZYyDIOLxDvDapNY35I7mpDCLtiqmTbJCcR3KAsZrzsx48y+V4+sGMqvjM8fvf63t69pEXYcMGfCZ4SBr8FLtTDd3M8PK4GM4M7ezQMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-down-cir.png
// module id = bxGd
// module chunks = 41